import React from 'react';

import QuestionFactory from 'qualification/components/QuestionFactory';
import QuestionHeader from 'qualification/components/QuestionHeader';
import { useQualification } from 'qualification/context';
import { QUALIFICATION_STATUS } from 'qualification/context/model';
import { Step } from 'qualification/schema/model';

interface Props {
  step: Step;
  child?: boolean;
}

function Question({ step, child = false }: Props) {
  const { state } = useQualification();
  if (state.status !== QUALIFICATION_STATUS.answering) {
    return null;
  }

  return (
    <React.Fragment>
      {'content' in step && (
        <QuestionHeader questionContent={step.content} child={child} />
      )}
      {step && (
        <QuestionFactory
          step={step}
          hasSidebar={!!state.qualification.selectedCaterer}
        />
      )}
    </React.Fragment>
  );
}

export default Question;
